<template>
  <loader v-if="loading"></loader>
  <load-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :cancel-button="true"
    :remove-button="$route.params.id !== 'new' && instance.permissions.delete"
    :edit-button="!editing && instance.permissions.update"
    :save-button="editing"
    remove-confirm-message="Vuoi veramente eliminare questo gruppo di lavoro?"
    @cancel="cancel"
    @remove="remove"
    @edit="edit"
    @save="save">
    <workgroup
      :value="instance"
      :errors="errors"
      :disabled="!editing"
      @input="instance = $event"
    />
    <debug-panel slot="debug">{{ instance }}</debug-panel>
  </load-page-layout>
</template>
<script>
import WorkgroupService from 'app/services/WorkgroupService';
import LoadPageMixin from 'vue-core/mixins/LoadPageMixin';

export default {
  mixins: [ LoadPageMixin ],

  created() {
    this.service = WorkgroupService;
  },

  computed: {
    breadcrumbs() {
      if (!this.instance) {
        return [];
      }
      
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Gruppi di lavoro',
          link: '/protected/workgroups'
        },
        {
          label: this.$route.params.id === 'new'
              ? '<Nuovo>'
              : (this.instance && this.instance.name || '<Gruppo di lavoro>')
        }
      ];
    },
  },

  methods: {
    cancel() {
      if (!this.instance.id || !this.editing) {
        this.$router.push({
          name: 'Workgroups'
        });
      } else {
        this.unedit();
      }
    },

    onRemoveSuccess({ statusCode, data}) {
      this.$router.push({
        name: 'Workgroups'
      });
    },
  }
};
</script>
